import cls from "classnames"
import { useCallback } from "react"

import styles from "./index.module.scss"

interface Props {
    channelId?: number
    nickName: string
    disableRoleSelect?: boolean
    hideRoleSelect?: boolean
    onRoleSelect?: () => void
    hideLogout?: boolean
    onLogout?: () => void
    className?: string
}

const UserInfo: React.FC<Props> = (props) => {
    const {
        channelId,
        nickName,
        disableRoleSelect,
        hideRoleSelect,
        hideLogout,
        onRoleSelect,
        onLogout,
        className,
    } = props

    const handleRoleSelect = useCallback(() => {
        if (disableRoleSelect) {
            return
        }

        onRoleSelect?.()
    }, [onRoleSelect, disableRoleSelect])

    return (
        <div
            className={cls(styles.userInfo, className)}
            onClick={handleRoleSelect}
        >
            <div className={styles.shadow}>
                <div className={styles.bg} />
            </div>
            <div className={styles.content}>
                <div className={styles.channel} data-channel={channelId} />
                <span className={styles.nickname}>
                    <b>{nickName}</b>
                </span>
                {!hideRoleSelect && (
                    <div
                        className={styles.switch}
                        onClick={(e) => {
                            e.stopPropagation()
                            handleRoleSelect()
                        }}
                    />
                )}
                {!hideLogout && (
                    <div
                        className={styles.logout}
                        onClick={(e) => {
                            e.stopPropagation()
                            onLogout?.()
                        }}
                    />
                )}
            </div>
        </div>
    )
}

export default UserInfo
